import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { AgendaCompletedTouchpoint } from "components/marketing-plan/marketing-plan-agenda";

export type AgendaSection = "overdue" | "dueToday" | "scheduledVisits" | "snoozed";

interface AgendaState {
    sectionVisibility: Record<AgendaSection, boolean>;
    recentlyCompleted: AgendaCompletedTouchpoint[];
}

export const initialState: AgendaState = {
    sectionVisibility: {
        overdue: true,
        dueToday: true,
        scheduledVisits: true,
        snoozed: false,
    },
    recentlyCompleted: [],
};

export const agendaSlice = createSlice({
    name: "agenda",
    initialState,
    reducers: {
        toggleAgendaSection: (state, action: PayloadAction<AgendaSection>) => {
            state.sectionVisibility[action.payload] =
                !state.sectionVisibility[action.payload];
        },
        reportRecentlyCompleted: (
            state,
            action: PayloadAction<AgendaCompletedTouchpoint[]>,
        ) => {
            const seen = new Set(state.recentlyCompleted.map(item => item.touchpointId));
            const fresh = action.payload.filter(item => !seen.has(item.touchpointId));
            state.recentlyCompleted = [...fresh, ...state.recentlyCompleted];
        },
        clearRecentlyCompleted: state => {
            state.recentlyCompleted = [];
        },
    },
});
